import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  user: any | null; // L'utilisateur peut être un objet ou null
  token: string | null; // Le token peut être une chaîne ou null
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  // Récupérer les valeurs initiales depuis localStorage, sinon initialiser à null
  user: localStorage.getItem('user') === 'undefined' ? null : JSON.parse(localStorage.getItem('user') || 'null'),
  token: localStorage.getItem('token') || null,
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // Action pour définir l'utilisateur et le token
    setUser: (state, action: PayloadAction<{ user: any; token: string }>) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      localStorage.setItem('token', action.payload.token); // Stocker le token dans localStorage
      localStorage.setItem('user', JSON.stringify(action.payload.user)); // Stocker les données utilisateur dans localStorage
    },
    
    // Action pour mettre à jour l'utilisateur (sans changer le token)
    updateUser: (state, action: PayloadAction<{ user: any }>) => {
      state.user = action.payload.user;
      localStorage.setItem('user', JSON.stringify(action.payload.user)); // Mettre à jour les données utilisateur dans localStorage
    },
    
    // Action pour gérer l'état de chargement (utile pour les appels API)
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    
    // Action pour gérer les erreurs
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    
    // Action pour la déconnexion
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.loading = false;
      state.error = null;
      localStorage.removeItem('token'); // Supprimer le token du localStorage
      localStorage.removeItem('user');  // Supprimer les données utilisateur du localStorage
    },
  },
});

export const { setUser, updateUser, setLoading, setError, logout } = userSlice.actions;

export default userSlice.reducer;
